import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Property } from '@app/shared/interfaces';

export const ensureMinStayRestrictionValidator = (
  propertyResolver: () => Property,
): ValidatorFn => {
  return (control: AbstractControl) => {
    const value = control.value;
    const property = propertyResolver();

    if (!value) {
      return null;
    }

    if (!property.mns_restriction.active || !property.mns_restriction.days) {
      return null;
    }

    if (value >= property.mns_restriction.days) {
      return null;
    }

    return {
      mnsLessThanRestriction: {
        requiredDays: property.mns_restriction.days,
      }
    }
  };
};
